<template>
  <router-view></router-view>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'app',
  methods: {
    ...mapActions('localization', ['loadLocalization']),
    ...mapActions('menu', ['loadMenuItems'])
  },
  mounted() {
    this.loadLocalization()
    this.loadMenuItems()
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue